import { render } from "./UnusedLeaveApprovals.vue?vue&type=template&id=07c9c0f7&scoped=true"
import script from "./UnusedLeaveApprovals.vue?vue&type=script&lang=js"
export * from "./UnusedLeaveApprovals.vue?vue&type=script&lang=js"

import "./UnusedLeaveApprovals.vue?vue&type=style&index=0&id=07c9c0f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c9c0f7"]])

export default __exports__